import { __decorate } from "tslib";
// NPM
import PageHeader from "@/components/page-header.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Layout from "@/router/layouts/main.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { OrganizationSettings } from "@/store/modules/organizationSetting.module";
import { setInteractionMode } from "vee-validate";
import { Component, Mixins } from "vue-property-decorator";
import HRMSProviderComponent from "./HRMSProviderComponent.vue";
import CalendarProviderComponent from "./CalendarProviderComponent.vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let IntegrationConfiguration = /** @class */ (() => {
    let IntegrationConfiguration = class IntegrationConfiguration extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.activeMenu = null;
            this.componentName = null;
        }
        get externalAPIIntegrations() {
            return OrganizationSettings.externalApiIntegrations;
        }
        setMenu(externalAPIIntegration) {
            this.activeMenu = externalAPIIntegration;
            this.SetComponent();
        }
        SetComponent() {
            this.componentName = this.activeMenu.integrationName.replace(/\s+/g, "") + "Component";
        }
        setActiveMenu() {
            this.activeMenu = this.externalAPIIntegrations[0];
            this.SetComponent();
        }
        created() { }
    };
    IntegrationConfiguration = __decorate([
        Component({
            name: "IntegrationConfiguration",
            components: {
                Layout,
                PageHeader,
                SectionLoader,
                HRMSProviderComponent,
                CalendarProviderComponent,
            },
        })
    ], IntegrationConfiguration);
    return IntegrationConfiguration;
})();
export default IntegrationConfiguration;
